module.exports = __webpack_public_path__ + "307227a17c8ae4e7b1e1671fb84ff9d0.pdf";